{
  "version": 1,
  "asset_id": "057e6f0e-4a9d-4ffe-bd72-b6a678a67ba9",
  "project_id": "39db9d3d-7b53-4499-b84e-1b89accf167e",
  "url": "/__l5e/assets-v1/057e6f0e-4a9d-4ffe-bd72-b6a678a67ba9/school-support-cutout.webp",
  "r2_key": "a/v1/39db9d3d-7b53-4499-b84e-1b89accf167e/057e6f0e-4a9d-4ffe-bd72-b6a678a67ba9/school-support-cutout.webp",
  "original_filename": "school-support-cutout.webp",
  "size": 51322,
  "content_type": "image/webp",
  "created_at": "2026-08-18T08:36:51Z"
}
